define('viewModels/privileged/qm/facetedSearch/SearchFacetsView',[
    'lib/knockout',
    'lib/lodash4',
    'moment',

    'viewModels/ViewModel',
    'util/searchFacetFactory',
    'util/dateTimeConstant',
    'services/loggingService',

    //no reference
    'extensions/i18n/knockout.i18n',
    'extensions/knockout.validation.extender'
], function(
    ko,
    _,
    moment,

    ViewModel,
    searchFacetFactory,
    dateTimeConstant,
    LOG
    ) {
    'use strict';

    var SearchFacetsView = ViewModel.extend(function (facetView, searchFilterList){
        var self = this;

        self.freeTextObservable = ko.observable();
        self.activeAccordions = ko.observableArray();
        self.loading = ko.observable(false);

        self.facetView = self.subView(facetView, self);

        // This will store the facets that have been selected as options
        self.facets = ko.observableArray();

        // This will store the visual filters
        self.selectedFilterViews = ko.observableArray();
        //This will store the query info
        self.filterQuery = ko.observableArray();

        // If we don't have a list of filters being passed in we should create an
        // observableArray
        if(searchFilterList){
            self.filterQuery = searchFilterList;
        } else {
            LOG.error("SearchFacetsView must have an observableArray as an argument");
        }

        self.freeTextFilter = {
            id: 'freeText',
            target: 'freeText',
            operator: 'contains',
            facetObservable: self.freeTextObservable,
            filterTitle: ko.i18n.renderString('searchFacet.filterTitle.text')
        };

        /**
         * createFilter
         *
         * Will take the information from the item to be added and create a filter that will be saved to searchFilterList
         * and passed on to create a filter view
         */
        var createFilterQuery = function(itemToAdd, filterValues) {

            if( _.has(itemToAdd, 'target') &&
                _.has(itemToAdd, 'operator') &&
                !_.isEmpty(filterValues)) {

                var filter = {
                    target: itemToAdd.target,
                    operator: itemToAdd.operator,
                    values: filterValues.values,
                    shouldNotSave: filterValues.shouldNotSave,
                    display: filterValues.display
                };
                self.filterQuery.push(filter);
                self.addFilterView(filter, itemToAdd);
            } else {
                LOG.error('Search filters must have "target", "operator" and "values" properties');
            }
        };

        /**
         * addCategory function
         *
         * Accepts a category determined by a view model and adds the properties of that category to the facets object
         *
         */
        self.addCategory = function(facetCategory) {
            if(!_.isEmpty(facetCategory)){
                self.facets().push(facetCategory);
            }
        };

        /**
         * addFilterView function
         *
         * Takes information from the item to be added and creates a filter view (pill) that will be positioned on the
         * tool bar
         *
         */
        self.addFilterView = function(filter, itemToAdd) {
            var display,
                tooltipInfo;

            /**
             * If there is no itemToAdd display we need to make one; this will happen when the user loads saved
             * searches or when the user navigates away from from a page with filters and returns. The user service
             * will save the search filter properties but only saves the target, operator and values.
             */

            if (_.isArray(filter.display)) {
                display = filter.display.length;
                tooltipInfo = filter.display;

            } else {
                display = filter.display;
            }

            // Construct the filter view and add it to the selected list
            self.selectedFilterViews.push({
                id: filter.target,
                data: {
                    filterTitle: itemToAdd.filterTitle,
                    displayText: display,
                    tooltip: tooltipInfo
                },
                template: 'templates/appMain/privilegedMain/qm/facetedSearch/filter',
                noCancel: filter.shouldNotSave,
                removeFilter: self.removeFilter
            });
        };

        /**
         * addUpdateFilter function
         *
         * Accepts the clicked facet item and first checks for duplication. If there is a duplicate it will remove it from
         * the view and list and then replace it with the updated  values. If there are no duplicates then a new view and
         * list item will be created.
         *
         */

        self.addUpdateFilter = function (facet) {
            var filterProperties;
            var savedFilter = false;
            var facetTarget;
            var facetIndexToUpdate;

            facetTarget = facet.target;

            if(facet.hasOwnProperty('listedItems')){
                filterProperties = ko.toJS(facet.listedItems);

            } else if (facet.hasOwnProperty('customRange')){
                filterProperties = facet.selectedRange;

            } else if (facet.hasOwnProperty('popover')) {
                filterProperties = facet.facetObservable();

            } else if( facet.hasOwnProperty('searchCriteria')) {
                filterProperties = facet.searchCriteria;

            } else {
                filterProperties = facet;
                savedFilter = true;
            }

            facetIndexToUpdate = _.findIndex(ko.toJS(self.facets()), {target: facetTarget});

            //check to see if we can update the filter by looking for built query
            var filterToUpdate = _.find(self.filterQuery(), function(item) {
                return item.target === facetTarget;
            });

            // check for the view filterView that needs to be updated
            var viewToUpdate = _.find(self.selectedFilterViews(), function(item) {
                return item.id === facetTarget;
            });

            //if one already exists we need to replace it and add the updated on
            if(filterToUpdate){
                if (filterToUpdate.target === facetTarget) {
                    _.pull(self.selectedFilterViews(), viewToUpdate);
                    _.pull(self.filterQuery(), filterToUpdate);
                }
            }

            if( facetTarget === "freeText"){
                createFilterQuery(self.freeTextFilter, filterProperties);
            } else if(savedFilter ){
                self.facets()[facetIndexToUpdate].facetObservable(filterProperties);
                createFilterQuery(self.facets()[facetIndexToUpdate], filterProperties);
            } else {
                createFilterQuery(self.facets()[facetIndexToUpdate], filterProperties);
            }
        };

        /**
         * removeFilter function
         *
         * accepts the index of the filter view (pill) and removes it from the view and filter list; will update the
         * observables
         *
         * @param index - index of the facet to be removed
         * @param data - for removal of the listedItems
         */
        self.removeFilter = function (item) {
            var index = _.findIndex(self.filterQuery(), {target: item.id});

            //Remove the view
            self.selectedFilterViews(_.pull(self.selectedFilterViews(), self.selectedFilterViews()[index]));
            // Remove the model
            self.filterQuery(_.pull(self.filterQuery(), self.filterQuery()[index]));

            //remove the listed
            var facetIndex = _.findIndex(ko.toJS(self.facets()), {target: item.id});
            if(_.has(self.facets()[facetIndex], "listedItems")) {
                self.removeItem(self.facets()[facetIndex], null);
            }
            if (!containsInterval()){
                self.addUpdateFilter(self.createDefaultFilter());
            }
        };

        function containsInterval(){
            if (!_.isEmpty(self.selectedFilterViews())){
                return !!_.find(self.selectedFilterViews(), function(view){
                    return view.id === "interval";
                });
            }
            return false;
        }

        /**
         * removeItem function
         *
         * removes items from the listed items
         *
         * @param facet
         * @param index
         */
        self.removeItem = function(facet, index){
            if(_.isNull(index)) {
                facet.listedItems.values([]);
                facet.listedItems.display([]);
            } else {
                facet.listedItems.values().splice(index, 1);
                facet.listedItems.display().splice(index, 1);

                // If the listedItems.value array is empty remove the filter
                if(_.isEmpty(facet.listedItems.values())) {
                    self.removeFilter(facet);
                    facet.facetObservable(null);
                } else {
                    self.addUpdateFilter(facet);
                    facet.facetObservable(facet);
                }
            }
        };

        self.createDefaultFilter = function(){
            var now = moment().endOf('day');
            var monthBefore = moment(now).subtract(30, "days").startOf('day');
            var nowDisplay = ko.i18n.formatDate(now);
            var monthsBeforeDisplay = ko.i18n.formatDate(monthBefore);
            var intervalString = monthBefore.toISOString() + "/" + now.toISOString();

            return {
                display: ko.i18n.renderString("dateRange.facet.default.display", {startDate: monthsBeforeDisplay, endDate: nowDisplay}),
                operator: "between",
                target: "interval",
                shouldNotSave: true,
                values: [intervalString]
            };
        };

        // Set up the facet sidebar options
        _.each(self.facetView.facets, function(facet) {
            self.addCategory(searchFacetFactory.createFacet(facet, self.removeItem, self.addUpdateFilter));
        });

        // Get the last saved filters from user service via SearchResultsView and show them in the UI
        self.createSavedFilterTemplates = function (lastSavedFilters) {
            _.each(lastSavedFilters, function(filter) {
                self.addUpdateFilter(filter);
            });
        };

        self.subscribe(self.freeTextObservable, function(newValue) {
            if(newValue){
                self.freeTextFilter.searchCriteria = {values: [newValue], display: newValue};
                self.addUpdateFilter(self.freeTextFilter);
                self.freeTextObservable('');
            }
        });

        ko.validation.group(self, {
            deep: true,
            live: true //Properly validate observable arrays
        });
    });
    return SearchFacetsView;
});

